import axios from './axios'
import config from '../config'

export default {
    listPages(params) {
        return axios({
            url: config.backendUrl + '/project/pages',
            method: 'GET',
            params
        })
    },
    addPage(params, data) {
        return axios({
            url: config.backendUrl + '/project/pages',
            method: 'POST',
            params,
            data
        })
    },
    updatePage(data) {
        return axios({
            url: config.backendUrl + '/project/pages',
            method: 'PUT',
            data
        })
    },
    updatePageConfig(id, data) {
        return axios({
            url: config.backendUrl + '/project/pages/' + id + '/config',
            method: 'PUT',
            data
        })
    },
    getPage(id) {
        return axios({
            url: config.backendUrl + '/project/pages/' + id,
            method: 'GET'
        })
    },
    deletePage(id) {
        return axios({
            url: config.backendUrl + '/project/pages/' + id,
            method: 'DELETE'
        })
    }
}
